
import { ToastContainer } from 'react-toastify';
import FormValidation from './components/Form';

function App() {
  
  return (
    <>
    <ToastContainer/>
    <FormValidation/>
    </>
  )
}

export default App;
